import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import classNames from 'classnames'
import mapDispatchers from '../utilities/mapDispatchers'
import icons from '../enums/icons'
import Img from './Img'
import styles from './InstagramAuthButton.icss'

class InstagramAuthButton extends Component {
	constructor(props) {
		super(props)

		this.state = {
			showProgress: false
		}

		this.doAuthInstagramRedirectLogin = this.doAuthInstagramRedirectLogin.bind(this)
	}

	doAuthInstagramRedirectLogin() {
		this.setState({ showProgress: true })
		// doing this to remove the native event object which cannot be passed around in the saga or you'll get "Warning: This synthetic event is reused for performance reasons."
		setTimeout(() => {
			global.requestAnimationFrame(this.props.authInstagramRedirectLogin)
		}, 250)
	}

	render() {
		return (
			<Button
				classes={{ root: styles.button, label: styles.label }}
				fullWidth
				onClick={this.doAuthInstagramRedirectLogin}
			>
				{this.state.showProgress &&
					<CircularProgress className={classNames(styles.logo, styles.instaColour)} size={24} thickness={4} />
				}
				{!this.state.showProgress &&
					<Img className={styles.logo} content={icons.brandInstagram} />
				}

				<span className={styles.text}>{this.context.translate('Login with Instagram')}</span>
			</Button>
		)
	}
}

InstagramAuthButton.contextTypes = {
	translate: PropTypes.func
}

InstagramAuthButton.propTypes = {
	authInstagramRedirectLogin: PropTypes.func.isRequired
}

export default connect(
	null,
	/* istanbul ignore next line */
	dispatch => mapDispatchers(dispatch, ['authInstagramRedirectLogin'])
)(InstagramAuthButton)



// WEBPACK FOOTER //
// ./src/components/InstagramAuthButton.jsx